<template>
  <div
    v-if="ready"
    :class="[rateableType, 'rating-component-container', { 'media-player': mediaPlayer }]"
  >
    <div class="heading">
      Was this helpful?
    </div>
    <div class="thumbs">
      <button @click="rate('up', asset, category)">
        <icon
          :name="iconName['up']"
          :variant="iconVariant"
        />
      </button>
      <button @click="rate('down', asset, category)">
        <icon
          :name="iconName['down']"
          :variant="iconVariant"
        />
      </button>
    </div>
  </div>
</template>

<script>
import Icon from '@components/singletons/icon';
import RatingMixin from '@/mixins/rating';

export default {
  components: { Icon },
  mixins: [RatingMixin],
  props: {
    asset: {
      type: Object,
    },
    category: {
      type: Object,
    },
    mediaPlayer:  {
      type: Boolean,
      default: false,
    },
    rateableId: {
      type: Number,
    },
    rateableType: {
      type: String,
    },
  },
  data() {
    return {
      collapsed: false,
    };
  },
  computed: {
    iconName() {
      const icons = {
        up: 'thumb-outline',
        down: 'thumb-outline',
      };

      if (this.rating?.rating === 1) {
          icons.up = 'thumb-filled';
      } else if (this.rating?.rating === 0) {
        icons.down = 'thumb-filled';
      }

      return icons;
    },
    iconVariant() {
      return this.mediaPlayer ? 'white' : 'mastery';
    },
    ready() {
      return this.rateableId && this.rateableType;
    },
  },
  created() {
    this.$watch('ratingKey', () => {
      this.$store.dispatch('ratings/fetch', { id: this.rateableId, type: this.rateableType });
    }, { immediate: true });
  },
};
</script>

<style lang='scss' scoped>
.rating-component-container {
  margin: rem-calc(48) auto;
  text-align: center;
  // weird spacing rules are required because safari has weird behavior
  // with making flex elements fill the entire container area
  max-width: rem-calc(200);
  min-width: 100%;
  width: 100%;
  z-index: 10000;

  &.Attachment.media-player {
    display: flex;
    justify-content: center;
    opacity: 0.9;
    max-width: rem-calc(280);

    .heading {
      color: white;
      margin-bottom: 0;
      margin-right: rem-calc(16);
    }
  }

  .heading {
    font-size: rem-calc(20);
    font-weight: $semi-bold;
    margin-bottom: rem-calc(16);
  }

  .thumbs {
    button {
      background: none;

      &:last-child img {
        margin-left: rem-calc(16);
        transform: rotate(180deg);
      }
    }
  }
}
</style>
